// Michigan Aviation Site Configuration
// Central place for all site constants and configuration

export const siteConfig = {
  name: 'Michigan Aviation',
  description: 'Full-service FBO and FAA-certified MRO at Oakland County International Airport (KPTK) in Waterford, Michigan.',
  airport: {
    code: 'KPTK',
    name: 'Oakland County International Airport',
    city: 'Waterford',
    state: 'Michigan',
  },
  contact: {
    phone: '(248) 666-3440',
    phoneRaw: '+12486663440',
    email: 'fly@michiganaviation.com',
  },
  address: {
    street: '6150 Highland Rd',
    city: 'Waterford Township',
    state: 'MI',
    postalCode: '48327',
    country: 'United States',
  },
  hours: {
    lineService: '5:00 AM to 11:00 PM daily, excluding holidays, and 24 hours with advance notice',
    lineServiceShort: '5:00 AM\u201311:00 PM daily, excluding holidays; 24 hours with advance notice',
  },
  fuelBrand: 'Phillips 66',
  established: 1957,
  yearsExperience: new Date().getFullYear() - 1957,
  pricing: {
    hangarPerSqFt: '13.50',
    officeMin: 750,
    officeMax: 1500,
  },
  // External URLs - replace with actual URLs when available
  flightBridgeUrl: 'https://flightbridge.com/go/michiganaviation',
  fuelAlertFormUrl: process.env.FUEL_ALERT_FORM || '#fuel-alerts',
  brands: [
    'Garmin',
    'Genesys Aerosystems',
    'Aspen Avionics',
    'Avidyne',
  ],
} as const
